import React, { Component } from "react";
import { Link } from "redux-little-router";
import "./index.css";
import { connect } from "react-redux";
import { signout } from "../../../../actions/userActions";
import { selectUser } from "../../../../util/selectors";
import { constructUserProfilePath } from "../../../../util/index";
import ProfilePicture from "../../../ProfilePicture";

class MobileMenu extends Component {
  componentWillUnmount() {
    if (this.props.open) {
      this.props.toggleMenu();
    }
  }

  render() {
    const { picture, name, uid, username } = this.props.user;
    const profilePath = constructUserProfilePath({ id: uid, username });

    return (
      <div className={`mobile-toggle-menu animated ${this.props.open ? "fadeIn" : "fadeOut"}`}>
        <div className="-menu-wrapper">
          <div className="-user-img-wrapper">
            <ProfilePicture userId={uid} size="s" fallbackUrl={picture} alt="User Name" className="-user-img" />
            <p className="-user-name">{name}</p>
          </div>
          <ul className={`-menu-list-wrapper ${this.props.open ? "-list-open" : ""}`}>
            <Link className="-list-item" href="/newcase">
              <li>New Case</li>
            </Link>
            <Link className="-list-item" href={profilePath} onClick={this.props.toggleMenu}>
              <li>My Profile</li>
            </Link>
            <Link className="-list-item" href="/preferences" onClick={this.props.toggleMenu}>
              <li>Preferences</li>
            </Link>
            <Link className="-list-item" href={`${profilePath}/collections`} onClick={this.props.toggleMenu}>
              <li>Collections</li>
            </Link>
            <li className="-list-item" onClick={this.props.actions.signout}>
              <span>Sign out</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: selectUser(state),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    signout: _ => dispatch(signout()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu);



// WEBPACK FOOTER //
// ./src/components/Header/Components/MobileMenu/index.js